import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { CustomAvatar } from 'components/custom-avatar';
import Iconify from '../../components/iconify';
import { convertToFormattedString } from '../../utils/helper';

// ----------------------------------------------------------------------

Accounts.propTypes = {
  sx: PropTypes.object, 
  account: PropTypes.object,
  onSelectAccount: PropTypes.func,
};

export function Accounts({
  sx, account, onSelectAccount
}) {
    const logo = account?.basicDetails?.logo && account?.basicDetails?.logo!==""?`https://technolitics-s3-bucket.s3.ap-south-1.amazonaws.com/maira-s3-bucket/${account?.basicDetails?.logo}`:account?.basicDetails?.name;
  return (
    <FileItem
      variant="outlined"
      sx={[
        {
          p: { xs: 2.5, sm: 2 },
          alignItems: { xs: 'unset', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          cursor: 'pointer',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]} 
      onClick={()=>onSelectAccount()}
    >
      {/* Replace these with your actual logo and content */}
      <Box component="span"><CustomAvatar alt={account?.basicDetails?.name} src={logo} name={account?.basicDetails?.name} /></Box> 
      <Box component="span">{account?.basicDetails?.name} <Box component="span" style={{fontSize: "small"}}>({convertToFormattedString(account?.basicDetails?.websiteType)})</Box></Box>
      
    </FileItem>
  );
}

export const FileItem = styled(Paper, {
  shouldForwardProp: (prop) => !['selected', 'sx'].includes(prop),
})(({ selected, theme }) => {
  // Use standard MUI shadows and palette instead of theme.vars
  const hoverStyles = {
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
  };

  return {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2.5),
    backgroundColor: 'transparent',
    borderRadius: Number(theme.shape.borderRadius) * 2,
    '&:hover': hoverStyles,
    ...(selected && hoverStyles),
  };
});
